import './set-public-path'
import './global.scss'
import luxLogo from './assets/imgs/logo_blue.svg'
import luxLogoWhite from './assets/imgs/logo_white.svg'
import luxLogoBg from './assets/imgs/logo_sfondo.svg'
import essilorLogo from './assets/imgs/essilor-logo.svg'
import essilorLogoPNG from './assets/imgs/essilor-logo.png'

import smartLogo from './assets/imgs/smartly-logo.png'
import smartExtendedLogo from './assets/imgs/smartly-extended-logo.png'

// Anything exported from this file is importable by other in-browser modules.
export function publicApiFunction() {}
export { luxLogo, luxLogoWhite, luxLogoBg, essilorLogo, essilorLogoPNG }
export { smartLogo, smartExtendedLogo }

import packageJson from '../package.json'
console.log(
    '%c' +
        packageJson.name +
        ' v' +
        packageJson.version +
        ' - ENVIRONMENT: ' +
        process.env.REACT_APP_ENV +
        ' - BUILD_TYPE: ' +
        process.env.NODE_ENV,
    'background: palevioletred; color: black; font-size:12px; padding: 5px;'
)
